/*
 * 调用方式
 * 1. 符合HTML约定, 引入模块即可
 * 2. 传入节点，属性符合规范
 */
define('widget/dropdown', ['jquery'], ($) => {
    const $document = $(document);

    function open($element) {
        $element.addClass('open');
        const $menu = $element.find('.js-dropdown-menu');

        $menu.show();
    }

    function close($element) {
        $element.removeClass('open');
        const $menu = $element.find('.js-dropdown-menu');

        $menu.hide();
    }

    function init() {
        $document
            .on('mouseenter', '.js-dropdown', function () {

                if(RRC.cityLimitEmission && $(this).attr('id') === 'filter_emission') {
                    return false;
                }
                open($(this));

            })
            .on('mouseleave', '.js-dropdown', function () {
                close($(this));
            });

        $document
            .on('click', '.js-dropdown .js-close', function () {
                close($(this).parents('.js-dropdown'));
            });
    }

    init();

    return {
        open,
        close,
    };
});

